import React from 'react';
import { Award, Users, Clock, Heart } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: <Award className="h-6 w-6 sm:h-8 sm:w-8 text-yellow-500" />,
      title: 'Authentic Recipes',
      description: 'Traditional Italian recipes passed down through generations'
    },
    {
      icon: <Users className="h-6 w-6 sm:h-8 sm:w-8 text-green-500" />,
      title: 'Family Owned',
      description: 'A new family business bringing authentic NY style flavors to Seattle'
    },
    {
      icon: <Clock className="h-6 w-6 sm:h-8 sm:w-8 text-blue-500" />,
      title: 'Fresh Daily',
      description: 'All ingredients sourced fresh daily from local markets'
    },
    {
      icon: <Heart className="h-6 w-6 sm:h-8 sm:w-8 text-red-500" />,
      title: 'Made with Love',
      description: 'Every dish prepared with passion and traditional methods'
    }
  ];

  return (
    <section id="about" className="py-12 sm:py-20 bg-gray-800">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-16 items-center">
          {/* Content */}
          <div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 sm:mb-6">
              Our <span className="text-red-600">Story</span>
            </h2>
            
            <p className="text-base sm:text-lg text-gray-300 mb-4 sm:mb-6 leading-relaxed">
              Hot Slice Pizza is a brand new family-owned restaurant bringing authentic halal Italian cuisine 
              to Seattle. With years of experience in making pizzas and having learned from some of the best chefs 
              from Italy, our dream is to share the genuine flavors of Italy with our community.
            </p>
            
            <p className="text-base sm:text-lg text-gray-300 mb-6 sm:mb-8 leading-relaxed">
              We combine time-honored Italian techniques with the freshest halal Pacific Northwest
              ingredients. From our deck oven pizzas by the slice to our handmade pasta and delicious appetizers,
              every bite tells a story of passion, tradition, and the finest ingredients.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start space-x-3 sm:space-x-4">
                  <div className="flex-shrink-0">{feature.icon}</div>
                  <div>
                    <h3 className="text-base sm:text-lg font-semibold text-white mb-1 sm:mb-2">{feature.title}</h3>
                    <p className="text-gray-400 text-sm">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="relative order-first lg:order-last">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="/Red%20and%20Beige%20Typographic%20Late%20Night%20Pizza%20Instagram%20Post%20(1).png"
                alt="Professional chef at Hot Slice Pizza expertly preparing fresh pizza dough in the kitchen"
                className="w-full h-64 sm:h-96 lg:h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/50 to-transparent"></div>
            </div>
            
            {/* Stats Cards */}
            <div className="absolute -bottom-4 sm:-bottom-8 -left-4 sm:-left-8 bg-red-600 rounded-2xl p-3 sm:p-6 shadow-xl">
              <div className="text-center">
                <div className="text-2xl sm:text-3xl font-bold text-white mb-1">New</div>
                <div className="text-red-100 text-xs sm:text-sm font-medium">Family Business</div>
              </div>
            </div>
            
            <div className="absolute -top-4 sm:-top-8 -right-4 sm:-right-8 bg-green-600 rounded-2xl p-3 sm:p-6 shadow-xl">
              <div className="text-center">
                <div className="text-2xl sm:text-3xl font-bold text-white mb-1">50+</div>
                <div className="text-green-100 text-xs sm:text-sm font-medium">Menu Items</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;